import React from 'react';

const Footer = () => {
    return (
        <div className="d-flex justify-content-center">Nicholas Kniola 2021</div>
    );
}

export default Footer;
